/**
 * TestResults Component - Shows code execution results
 */
import React from 'react';
import './TestResults.css';

function TestResults({ results }) {
  if (!results) return null;

  const { summary, results: cases } = results;

  return (
    <div className="test-results">
      {/* Summary Bar */}
      <div className={`results-summary ${summary.allPassed ? 'all-passed' : 'some-failed'}`}>
        <div className="summary-icon">{summary.allPassed ? '✅' : '❌'}</div>
        <div className="summary-text">
          <strong>{summary.allPassed ? 'All tests passed!' : `${summary.failed} test(s) failed`}</strong>
          <span>{summary.passed}/{summary.total} passed</span>
        </div>
        <div className="summary-bar">
          <div
            className="summary-bar-fill"
            style={{ width: `${(summary.passed / summary.total) * 100}%` }}
          />
        </div>
      </div>

      {/* Individual Test Cases */}
      <div className="test-cases">
        {cases.map((tc, i) => (
          <div key={tc.testCaseId} className={`test-case ${tc.passed ? 'passed' : 'failed'}`}>
            <div className="test-case-header">
              <span className="tc-status">{tc.passed ? '✓' : '✗'}</span>
              <span className="tc-label">
                Test Case {i + 1}
                {!tc.isPublic && <span className="tc-hidden">(hidden)</span>}
              </span>
              <span className="tc-time">{tc.executionTime}</span>
            </div>

            {tc.isPublic && (
              <div className="test-case-body">
                <div className="io-row">
                  <span className="io-label">Input</span>
                  <pre className="io-val">{tc.input}</pre>
                </div>
                <div className="io-row">
                  <span className="io-label">Expected</span>
                  <pre className="io-val expected">{tc.expected}</pre>
                </div>
                <div className="io-row">
                  <span className="io-label">Got</span>
                  <pre className={`io-val ${tc.passed ? 'correct' : 'wrong'}`}>
                    {tc.error ? `Error: ${tc.error}` : tc.actual || '(empty)'}
                  </pre>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default TestResults;
